import { styled } from '@mui/material';
import { colors } from 'app/theme/config';

// Clipped to 1px until focused, then revealed pinned to the viewport (fixed) so content above it
// (e.g. the cookie banner) can't push it into view.
export const SkipLinkAnchor = styled('a')(({ theme }) => ({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
  '&:focus, &:focus-visible': {
    position: 'fixed',
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: theme.zIndex.tooltip + 1,
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(1, 2),
    margin: 0,
    overflow: 'visible',
    clip: 'auto',
    clipPath: 'none',
    backgroundColor: colors.white,
    color: colors.black,
    borderRadius: theme.shape.borderRadius,
    textDecoration: 'underline',
  },
}));
